module.exports = __webpack_public_path__ + "img/pcb.74c484fd.jpg";